import React, { useEffect } from "react";
import { Link } from "react-router-dom";

import logo from "../../shared/assets/images/logo_white.png";
import { pageNames } from "../../shared/config/pageNames";
import { routerPathNames } from "../../shared/config/routerPathNames";

import "./Toolbar.scss";

const Toolbar = ({ currentPage, handleSetCurrentPage }) => {
  useEffect(() => {
    /** Initial menu highlight * */
    /*switch (window.location.pathname) {
      case routerPathNames.Map:
        handleSetCurrentPage(pageNames.Map);
        break;
      case routerPathNames.Reports:
        handleSetCurrentPage(pageNames.Reports);
        break;
      default:
        break;
    }*/
    if (window.location.pathname.includes(routerPathNames.Reports)) {
      handleSetCurrentPage(pageNames.Reports);
    } else if (window.location.pathname.includes(routerPathNames.Map)) {
      handleSetCurrentPage(pageNames.Map);
    }
    return () => {};
  }, []);

  return (
    <div className="toolbar">
      <div className="toolbar-nav">
        <div
          className={`toolbar-nav-item ${
            currentPage === pageNames.Map ? "toolbar-nav-item-selected" : ""
          }`}
        >
          <Link to="/" onClick={() => handleSetCurrentPage(pageNames.Map)}>
            Map
          </Link>
        </div>
        <div
          className={`toolbar-nav-item ${
            currentPage === pageNames.Reports ? "toolbar-nav-item-selected" : ""
          }`}
        >
          <Link
            to="/reports"
            onClick={() => handleSetCurrentPage(pageNames.Reports)}
          >
            Reports
          </Link>
        </div>
      </div>
      <div className="toolbar-title">LynxSights for Retail</div>
      <div className="toolbar-logo">
        <img id="lynxLogo" src={logo} alt="LynxLogo" />
      </div>
    </div>
  );
};

/*
      <nav className="topBarNav">
        <ul>
          <li
            className={`navItem ${
              currentPage === pageNames.Map ? "highlighted" : ""
            }`}
            onClick={() => handleSetCurrentPage(pageNames.Map)}
          >
            <Link className="navLink" to="/">
              Map
            </Link>
          </li>
          <li
            className={`navItem ${
              currentPage === pageNames.Reports ? "highlighted" : ""
            }`}
            onClick={() => handleSetCurrentPage(pageNames.Reports)}
          >
            <Link className="navLink" to="/reports">
              Reports
            </Link>
          </li>
        </ul>
      </nav>
      <div className="logo">
        <img id="lynxLogo" src={logo} alt="LynxLogo" />
      </div>
 */
export default Toolbar;
